module.exports = __webpack_public_path__ + "media/images/app/homepage/hero_mobile-80e35bcb18b21e167116c5949b4d2333.webp";